export const convertDestinations = (destinations, destinationType) =>
  destinations
    .filter(
      (dest) =>
        dest.destinationType === destinationType || dest.destinationType === -1
    )
    .map((dest) => ({ title: dest.name, value: dest.id }));

export const convertDeparture = (destinations) =>
  destinations
    .filter(
      (dest) =>
        dest.name.toLowerCase() === 'novi pazar'
    )
    .map((dest) => ({ title: dest.name, value: dest.id }));
